// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Browser } from '@capacitor/browser'
import { Capacitor } from '@capacitor/core'
import { createDomain, createStore, sample } from 'effector'
import { createGate } from 'effector-react'
import { AxiosErrorType, BalanceRefill, TypePayment } from '~/shared/api'
import { logger } from '~/shared/lib/logger'
import { mapJsonApiMessageErrors } from '~/shared/lib/mapMessageErrors'
import { snackbarEnqueued } from '~/shared/lib/notifications'

const domain = createDomain('widgets.newTinkoffPay')

export const Gate = createGate<{ amount: number }>()

export const payWithCardClicked = domain.createEvent<Window | null>()
export const payWithQrClicked = domain.createEvent<Window | null>()

export const getPaymentUrlFx = domain.createEffect<
  { amount: number; typePayment: TypePayment; win: Window | null },
  { url: string; win: Window | null },
  AxiosErrorType
>({
  async handler({ amount, typePayment, win }) {
    const url = await BalanceRefill.getPaymentUrl(amount, typePayment)
    return { url, win }
  },
})

const openUrlFx = domain.createEffect<
  { url: string; win: Window | null },
  void
>({
  async handler({ url, win }) {
    if (Capacitor.isNativePlatform()) {
      await Browser.open({ url })
    } else if (win && !win.closed) {
      win.location.href = url
    } else {
      window.open(url, '_blank')
    }
  },
})

export const $amount = createStore<number>(0).on(
  Gate.open,
  (_, { amount }) => amount,
)

export const $isCardLoading = domain
  .createStore<boolean>(false)
  .on(payWithCardClicked, () => true)
  .on(getPaymentUrlFx.finally, () => false)
  .reset(Gate.close)

export const $isQrLoading = domain
  .createStore<boolean>(false)
  .on(payWithQrClicked, () => true)
  .on(getPaymentUrlFx.finally, () => false)
  .reset(Gate.close)

sample({
  clock: payWithCardClicked,
  source: $amount,
  fn: (amount, win) => ({ amount, typePayment: TypePayment.CARD, win }),
  target: getPaymentUrlFx,
})

sample({
  clock: payWithQrClicked,
  source: $amount,
  fn: (amount, win) => ({ amount, typePayment: TypePayment.QR, win }),
  target: getPaymentUrlFx,
})

sample({
  clock: getPaymentUrlFx.doneData,
  target: openUrlFx,
})

sample({
  clock: getPaymentUrlFx.fail,
  fn({ params, error }) {
    params.win?.close()
    logger.error(error)
    return {
      message: mapJsonApiMessageErrors(error),
      variant: 'danger' as const,
    }
  },
  target: snackbarEnqueued,
})
